@let texts = textStore.texts();
@if (reconRouteStore.isLoading()) {
  <aw-loading-animation></aw-loading-animation>
} @else if (
  ctx() &&
  reconRouteStore.reconRoutes() &&
  reconRouteStore.reconRoutes().length > 0 &&
  !reconRouteStore.isLoading()
) {
  <div
    class="flex flex-row items-center justify-between gap-4 rounded-lg border-1 p-6"
    [ngStyle]="{
      borderRadius: corporateDesign.borderRadius(),
      borderColor: corporateDesign.primaryBorderColor(),
      backgroundColor: corporateDesign.surface1(),
    }">
    @let reconRoute = reconRouteStore.reconRoute();
    <div class="flex flex-col gap-4 font-black">
      <div class="flex flex-row items-center gap-2">
        <span>{{
          texts
            | filterTexts: ERelationType.from : EEntityType.journeyPlanner
            | language
        }}</span>
        <span>{{ reconRoute.origin.name }}</span>
        <span class="material-symbols-rounded">arrow_forward</span>
        <span>{{
          texts
            | filterTexts: ERelationType.to : EEntityType.journeyPlanner
            | language
        }}</span>
        <span> {{ reconRoute.destination.name }}</span>
      </div>
      <div class="flex flex-row items-center gap-2 text-sm">
        <span class="material-symbols-rounded">calendar_month</span>
        <span>{{
          texts
            | filterTexts: ERelationType.date : EEntityType.journeyPlanner
            | language
        }}</span>
        <span
          >{{
            reconRoute.origin.date | date: dateFormatSupport.activeDateFormat()
          }}
          {{ formatJourneyTime(reconRoute.origin.time) }}</span
        >
      </div>
    </div>
    <aw-button
      type="button"
      [style]="'primary-alt'"
      id="'journey-planner-redirect-change'"
      (click)="redirectToJourneyPlanning()"
      (keydown.enter)="redirectToJourneyPlanning()"
      >{{
        texts
          | filterTexts: ERelationType.button : EEntityType.journeyPlanner
          | language
      }}</aw-button
    >
  </div>
} @else {
  <div
    class="flex flex-col gap-4 rounded-lg border-1 p-6"
    [ngStyle]="{
      borderRadius: corporateDesign.borderRadius(),
      borderColor: corporateDesign.primaryBorderColor(),
      backgroundColor: corporateDesign.surface1(),
    }">
    <div class="pb-4 text-center text-2xl font-semibold">
      {{
        texts
          | filterTexts: ERelationType.headline : EEntityType.journeyPlanner
          | language
      }}
    </div>
    <div class="flex flex-row items-center justify-center">
      <aw-button
        type="button"
        id="'journey-planner-redirect'"
        (click)="redirectToJourneyPlanning()"
        (keydown.enter)="redirectToJourneyPlanning()"
        >{{
          texts
            | filterTexts: ERelationType.button : EEntityType.journeyPlanner
            | language
        }}</aw-button
      >
    </div>
  </div>
}
